import { ScanBarcode } from 'lucide-react'
import { useNavigate, useSearchParams } from 'react-router'
import ScanningImg from '@/assets/images/scanning-Item.png'
import { useGoBack } from '@/hooks/use-go-back'
import { emitMilestone } from '@/player/sim-progress'
import { AppHeader } from '@/ui/app-header'
import { Button } from '@/ui/button'

function StocktakeStartScreen() {
  const navigate = useNavigate()
  const goBack = useGoBack()
  const [searchParams] = useSearchParams()
  const noStocktake = searchParams.get('noStocktake') === '1'

  return (
    <div className="flex h-full flex-col bg-background">
      <AppHeader title="Stocktake" onBack={() => goBack()} />

      {noStocktake ? (
        <div className="flex flex-1 items-center justify-center">
          <div
            className="flex flex-col items-center justify-center gap-2 px-4"
            data-tour="stocktake-start"
          >
            <img src={ScanningImg} className="w-32 h-32" alt="" />
            <div className="mt-2 flex flex-col items-center gap-2">
              <p className="text-xl font-bold text-foreground text-center">No stocktake today</p>
              <p className="text-base text-muted-foreground text-center max-w-77">
                Please contact your BM for details regarding the next stocktake.
              </p>
            </div>
          </div>
        </div>
      ) : (
        <>
          <div className="flex flex-1 items-center justify-center">
            <div
              className="flex flex-col items-center justify-center gap-2 px-4"
              data-tour="stocktake-start"
            >
              <img src={ScanningImg} className="w-32 h-32" alt="" />
              <div className="mt-2 flex flex-col items-center gap-2">
                <p className="text-xl font-bold text-foreground text-center">
                  Start Your Stocktake
                </p>
                <p className="text-base text-muted-foreground text-center max-w-77">
                  Scan a location to start counting
                </p>
              </div>
            </div>
          </div>

          <div className="bg-background px-4 pb-[max(2.5rem,env(safe-area-inset-bottom,0px))] pt-4 shadow-[0px_-4px_5px_rgba(0,0,0,0.05)]">
            <Button
              data-tour="stocktake-start-btn"
              className="h-12 w-full rounded-full gap-2"
              onClick={() => {
                emitMilestone('stocktake-started')
                void navigate('/stocktake/scan-location')
              }}
            >
              <ScanBarcode className="size-5" />
              Start stocktake
            </Button>
          </div>
        </>
      )}
    </div>
  )
}

export default StocktakeStartScreen
